export const TableHelpers = {
    data() {
        return {
            tableColumns: [ 
            {
                title: this.$t('Expediente'),
                type: 'text',
                key: 'record',
            },
            {
                title: this.$t('Organismo'),
                type: 'custom-html',
                key: 'organization',
                modifier:(value)=>{
                    return value.business_name;
                }
            },
            {
                title: this.$t('Tipo acreditación'),
                type: 'text',
                key: 'tipo_acreditacion',
            },
            {
                title: this.$t('Estado'),
                type: 'custom-html',
                key: 'status',
                modifier:(value)=>{
                    return value.name;
                }
            }, 
            // {
            //     title: this.$t('Tiempo disponible (Meses)'),
            //     type: 'custom-html',
            //     key: 'remaining_time_vigilance',
            //     modifier: (value) => {
            //         let tmp;
            //         if (value) {
            //             if (value <= 1) {
            //                 tmp = `<span class="badge badge-sm badge-pill badge-danger">${value}</span>`;
            //             }
            //             if (value > 3) {
            //                 tmp = `<span class="badge badge-sm badge-pill badge-success">${value}</span>`;
            //             }
            //             if (value > 1 && value <= 2) {
            //                 tmp = `<span class="badge badge-sm badge-pill badge-warning">${value}</span>`;
            //             }

            //         } else {
            //             tmp = `<span class="badge badge-sm badge-pill badge-danger">0</span>`;
            //         }
            //         return tmp;
            //     }
            // },

            {
                title: this.$t('Fecha creación'),
                type: 'custom-html',
                key: 'created_at',
                modifier: (value) => {
                    if (value) {
                        return moment(value).format("YYYY-MM-DD");
                    }
                }
            },
            ],
            actionObj: {
                title: this.$t('Acciones'),
                type: 'action',
            }
        }
    },
}